function escapeRegex(value: string) {
  return value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

function patternToRegex(pattern: string) {
  if (pattern === '*') return /.*/i;
  const escaped = escapeRegex(pattern).replace(/\\\*/g, '.*');
  return new RegExp(`^${escaped}$`, 'i');
}

export function matchesPattern(value: string, pattern: string) {
  if (!pattern) return false;
  // Support wildcard subdomain patterns like *.example.com
  if (pattern.startsWith('*.')) {
    const root = pattern.slice(2).toLowerCase();
    const lower = value.toLowerCase();
    return lower === root || lower.endsWith(`.${root}`);
  }
  return patternToRegex(pattern).test(value);
}

export function isHostAllowed(hostname: string, allowed: string[] = [], blocked: string[] = []) {
  if (blocked.length && blocked.some(pattern => matchesPattern(hostname, pattern))) return false;
  if (!allowed.length) return true;
  return allowed.some(pattern => matchesPattern(hostname, pattern));
}

export function isOriginAllowed(origin: string, allowedOrigins: string[] = []) {
  if (!allowedOrigins.length) return true;
  return allowedOrigins.some(pattern => matchesPattern(origin, pattern));
}
